/** Hydrate the page-local customer catalog without conflating leaf and priced entry-date roles. */
export function hydrateCustomerTicketSelection(payload) {
    const events = {};
    const fullDates = {};
    Object.entries(payload.events).forEach(([eventId, entry]) => {
        const dates = {};
        Object.entries(entry.dates).forEach(([dateId, row]) => {
            dates[dateId] = {...entry.event, ...row, allDates: [], pendingDates: [], priceData: null};
        });
        const allDates = entry.allDateIds.map(id => dates[id]);
        const pendingDates = entry.pendingDateIds.map(id => dates[id]);
        events[eventId] = {...entry.event, allDates, pendingDates, priceData: entry.prices[entry.anchorDateId] || null};
        fullDates[eventId] = {};
        Object.entries(entry.prices).forEach(([dateId, priceData]) => {
            if (dates[dateId]) {
                fullDates[eventId][dateId] = {...dates[dateId], allDates, pendingDates, priceData};
            }
        });
    });
    const context = payload.entryContext;
    const entryContext = context ? {
        ...context,
        preselectedEvent: events[context.preselectedEventId] || null,
        preselectedEventDate: fullDates[context.preselectedEventId]?.[context.preselectedEventDateId] || null,
    } : null;
    return {
        events,
        fullDates,
        entryContext,
        legacyEvent: events[payload.legacyEventId] || null,
        legacyDate: fullDates[payload.legacyEventId]?.[payload.legacyDateId] || null,
    };
}
